import { isPositiveNumber } from "et3-type-guards";
import { memoize } from "lodash";
import { observable } from "mobx";

import getUserAdvancedStore from "../../user-store/advanced-store";

class CoreSideMenuStore {
  sideBarSearchText = observable.box<number>(-1);

  handleSearch = async () => {
    const userID = this.sideBarSearchText.get();
    const isDefinedUserId = isPositiveNumber(userID);
    if (!isDefinedUserId) {
      return;
    }
    getUserAdvancedStore().setSearchType("option_search");
    getUserAdvancedStore().setSearchByInput("userId");
    getUserAdvancedStore().advancedSearchInput.set(userID);
    await getUserAdvancedStore().getUserData(false);
  };
}
const getCoreSideMenuStore = memoize(
  () => new CoreSideMenuStore(),
  () => 1
);
export default getCoreSideMenuStore;
